require('../index.scss')
require('./index.scss')
import PropTypes from 'prop-types'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import MediaQuery from 'react-responsive'

import screen_sizes from '@/constants/screen_sizes'
import { fetchAssetDetails } from '@/reducers/asset/asyncActions'

import Desktop from './Desktop'
import Mobile from './Mobile'

const ProductDetails = ({
  assetId,
  duration,
  isPrint,
  kind,
  role
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchAssetDetails({ assetId, duration, role }))
  }, [])

  return (
    <div>
      <MediaQuery minWidth={screen_sizes.sm}>
        <Desktop isPrint={isPrint} kind={kind} />
      </MediaQuery>
      <MediaQuery maxWidth={screen_sizes.sm - 1}>
        <Mobile isPrint={isPrint} kind={kind} />
      </MediaQuery>
    </div>
  )
}

ProductDetails.propTypes = {
  assetId: PropTypes.number.isRequired,
  duration: PropTypes.string,
  isPrint: PropTypes.bool.isRequired,
  kind: PropTypes.string,
  role: PropTypes.string.isRequired,
}

export default ProductDetails
